<template>
  <TransitionRoot
    :show="show"
    as="template"
  >
    <Dialog
      as="div"
      class="fixed z-10 inset-0 overflow-y-auto"
      @close="closeModal()"
    >
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >&#8203;</span>

        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-[24rem] sm:w-[32rem]">
            <div class="p-8">
              <div class="text-center grid space-y-6">
                <p class="text-blue-400 text-xl font-bold">
                  {{ __('label_exit_header') }}
                </p>

                <p class="text-gray-500">
                  {{ __('label_exit_text') }}
                </p>

                <p class="text-gray-500 text-sm">
                  {{ __('label_exit_disclaimer') }}
                </p>

                <p v-if="campaignSubs.length > 0">
                  {{ __('label_exit_items_header') }}
                </p>

                <div
                  v-for="(campaignSub, index) in campaignSubs"
                  :key="index"
                  class="flex justify-center"
                >
                  <ExitItem
                    :campaign-sub="campaignSub"
                    :primary-color="primaryColor"
                    :secondary-color="secondaryColor"
                  />
                </div>
              </div>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {Dialog, DialogOverlay, TransitionChild, TransitionRoot} from '@headlessui/vue';
import ExitItem from '@timon/js/Components/ExitItem.vue';

defineProps({
  show: {
    type: Boolean,
    required: true,
  },

  campaignSubs: {
    type: Array,
    required: true,
  },

  primaryColor: {
    type: String,
    required: true,
  },

  secondaryColor: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
};
</script>
